module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "offset-sm": "3"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("\n            If the email entered corresponds to an active account, a reset link has been emailed to it.\n          ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "",
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Return to Login")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078e7efa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/PasswordResetConfirm.vue
// module id = 421
// module chunks = 1